import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-black",
  "use": "icon-black-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-black\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 896v-128h512v128H512z m0-448h512v128H512V448z m0-320h512v128H512V128zM0 960v-320h384v384H0v-64z m128-64h128v-128H128v128zM0 320V0h384v384H0V320z m128-64h128V128H128v128z\" p-id=\"6704\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-black.svg
// module id = V0+m
// module chunks = 120